export default "<app-header></app-header>\n<router-outlet></router-outlet>\n<app-footer></app-footer>"